import { useEffect } from 'react';
import { NewLaneEvent } from '../../../eventing/NewLaneEvent';
import { GTMEvent } from '../../../eventing/GTMEvent';
import { formNewLaneEventPayload } from '../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../eventing/clickStreamEventSchema';
import { DSP_BRAND, DSP_EXPERIENCE } from '../constants';
import { onsiteMessageEventPropTypes, defaultOnsiteMessageEventPropTypes } from './OnsiteMessageEventingTypes';
import { NBANewLaneEvent } from '../../../eventing/NBANewLaneEvent';
import { NBA_CLICKSTREAM_EVENT_TYPE } from '../../../eventing/nbaClickstreamEventSchema';
import { formNBANewLaneEventPayload } from '../../../eventing/nbaNewLaneEventPayload';
export var useOnsiteMessagingIntentToShowEvent = function useOnsiteMessagingIntentToShowEvent(_ref) {
  var eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      _ref$gaEventData = _ref.gaEventData,
      gaEventData = _ref$gaEventData === void 0 ? {} : _ref$gaEventData,
      _ref$signalForTrigger = _ref.signalForTriggerTracking,
      signalForTriggerTracking = _ref$signalForTrigger === void 0 ? true : _ref$signalForTrigger;
  useEffect(function () {
    if (signalForTriggerTracking) {
      NewLaneEvent({
        brand: DSP_BRAND,
        experience: DSP_EXPERIENCE,
        sharedJsonStr: JSON.stringify(Object.assign({
          event_type: 'intent_to_show'
        }, eventData))
      }, formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTENT_TO_SHOW, newLaneEventData, additionalClickStreamData || {}), gaEventData);
      GTMEvent(newLaneEventData);

      if ((newLaneEventData === null || newLaneEventData === void 0 ? void 0 : newLaneEventData.isNbaProcessed) === true) {
        NBANewLaneEvent(formNBANewLaneEventPayload(NBA_CLICKSTREAM_EVENT_TYPE.INTENT_TO_SHOW, newLaneEventData, ''));
      }
    } // eslint-disable-next-line zillow/react-hooks/exhaustive-deps

  }, [signalForTriggerTracking]);
};
useOnsiteMessagingIntentToShowEvent.propTypes = onsiteMessageEventPropTypes;
useOnsiteMessagingIntentToShowEvent.defaultProps = defaultOnsiteMessageEventPropTypes;